import { render } from "./alunosAtivos.vue?vue&type=template&id=87973164&scoped=true"
import script from "./alunosAtivos.vue?vue&type=script&lang=js"
export * from "./alunosAtivos.vue?vue&type=script&lang=js"

import "./alunosAtivos.vue?vue&type=style&index=0&id=87973164&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87973164"]])

export default __exports__